export const TrimText = (value, size = 40) => {
  return value != undefined && value.length > size ? value.slice(0, size) + "..." : value;
};